import type { LoadingQueryKey } from './types';

export const updateLoadingState = ({
  reducerDispatch,
  data,
}: {
  reducerDispatch: React.Dispatch<{ type: 'UPDATE_LOADING_STATE'; payload: { key: LoadingQueryKey; value: boolean } }>;
  data: Partial<Record<LoadingQueryKey, boolean>>;
}) => {
  Object.entries(data).forEach(([key, value]) => {
    reducerDispatch({
      type: 'UPDATE_LOADING_STATE',
      payload: { key: key as LoadingQueryKey, value },
    });
  });
};
